import { gql } from "apollo-boost";
import Error from 'components/alerts/Error';
import { Card } from 'components/common/card/Card';
import { ContentLoader } from "components/common/loader/ContentLoader";
import { getUsers } from 'components/graphql/queries';
import { createTicketBankItem, createTicketBankItemWithoutWebsocket, disable, getTicketBankItemsAsString, updateQuantity } from 'components/graphql/queries/ticketBank';
import { closeModal, openModal } from 'components/modal/modules/dispatcher/methods';
import * as JSCookie from 'js-cookie';
import TicketInventoryTableHeader from 'pages/manage/events/edit/modules/ticketInventory/modules/TicketInventoryTableHeader';
import React from 'react';
import { Subscription } from "react-apollo";
import { connect } from 'react-redux';
import { CardHeader, Collapse, Label } from 'reactstrap';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UsersDucks from 'stores/ducks/Users.duck';

import { deleteTicketItem } from '../../../../../../components/graphql/queries/ticketBank';
import CreateTicketModal from './modules/CreateTicketModal';
import TicketInventoryItem from './modules/TicketInventoryItem';

import { AppConfig } from 'config/app';

enum TicketInventoryDomain {
  PUBLIC = "public",
  PRIVATE = "private"
}

class ReferralTicketInventory extends React.Component<
  {
    ticketInventory: any;
    promoters: any;
    hosts: any;
    users: any;
    dispatch: any;
    eventId: string;
    currency: string;
    capacity: number;
  },
  {
    [label: string]: any;
  }
  > {
  constructor(props) {
    super(props);

    // Handlers..
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleEnabled = this.handleEnabled.bind(this);
    this.handleModalInputChange = this.handleModalInputChange.bind(this);
    this.handleOpenCreateModal = this.handleOpenCreateModal.bind(this);
    this.handleAddTicket = this.handleAddTicket.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCreateItem = this.handleCreateItem.bind(this);
    this.showOrHide = this.showOrHide.bind(this);
    this.setPromoter = this.setPromoter.bind(this);
    this.reloadData = this.reloadData.bind(this);
    // Other methods..
    this.mapTicketInventoryState = this.mapTicketInventoryState.bind(this);
    this.findTicketInventoryItemByIndex = this.findTicketInventoryItemByIndex.bind(this);

    // We need to set default state, and merge it with props..
    this.state = {
      showMap: {},
      redirect: false,
      loading: true,
      ticketInventoryPublic: [],
      ticketInventoryPrivate: [],
      ticketInventoryMap: {},
      ticketInventoryPromoterMap: {},
      ticketInventoryInactiveMap: {},
      teamMap: {
        code: '',
        customSubdomain: '',
        teamMap: [{
          userId: '', index: '', referralLinkViews: 0
        }],
      },
      updateString: null,
      updateString1: null,
      updateString2: null,
      updateString3: null,
      ticketInventoryNew: {
        name: null,
        quantity: 0,
        promoterId: null,
        price: 0,
        isChanged: true,
        description: null
      },
      capacityRemaining: 0,
      deletedUsers: [],
      ...props
    };
  }

  public componentDidMount() {
    const { eventId } = this.props;

    fetchGraphQL(getTicketBankItemsAsString(), JSCookie.get("token"), {
      eventId
    }).then((resultInventory: any) => {
      fetchGraphQL(`
        query {
          url {
            get(eventId: "${eventId}") {
              code
              customSubdomain
              teamMap {
                userId
                index
                referralLinkViews
              }
            }
          }
        }
        `).then(res => {
        this.setState({
          teamMap: res.url.get || {
            code: '',
            customSubdomain: '',
            teamMap: [{
              userId: '', index: '', referralLinkViews: 0
            }]
          },
          loading: false
        })
        const eventTicketInventory: any[] = JSON.parse(resultInventory.ticketBank.getAsString) || [];
        this.mapTicketInventoryState(eventTicketInventory);
      })
    });


  }

  public reloadData(updateNum: any, num: number) {

    if (num === 1) {
      this.setState({ updateString: updateNum })
    } else if (num === 2) {
      this.setState({ updateString1: updateNum })
    } else if (num === 3) {
      this.setState({ updateString2: updateNum })
    } else if (num === 4) {
      this.setState({ updateString3: updateNum })
    }

    const { eventId } = this.props;

    fetchGraphQL(getTicketBankItemsAsString(), JSCookie.get("token"), {
      eventId
    }).then((resultInventory: any) => {
      fetchGraphQL(`
        query {
          url {
            get(eventId: "${eventId}") {
              code
              teamMap {
                userId
                index
                referralLinkViews
              }
            }
          }
        }
        `).then(res => {
        this.setState({
          teamMap: res.url.get || {
            code: '',
            teamMap: [{
              userId: '', index: '', referralLinkViews: 0
            }]
          },
        })
      })
      const eventTicketInventory: any[] = JSON.parse(resultInventory.ticketBank.getAsString) || [];
      this.mapTicketInventoryState(eventTicketInventory);
    });

    return undefined;
  }

  public showOrHide(promoterId: string) {
    if (this.state.showMap[promoterId] === undefined) {
      this.setState({
        showMap: {
          ...this.state.showMap, [promoterId]: true
        }
      })
    } else {
      this.setState({
        showMap: {
          ...this.state.showMap, [promoterId]: !this.state.showMap[promoterId]
        }
      })
    }
  }

  /**
   * Used to map received props from parent - ticketInventoryItems
   * to state, and create "hashMap" -> ID : Index
   */
  public mapTicketInventoryState(eventTicketInventory: any[]) {
    const { props } = this;
    const ticketInventory: { public: any[]; private: any[] } = {
      public: [],
      private: []
    };

    let totalAllocatedTicket = 0;

    eventTicketInventory.forEach((titem: any) => {
      totalAllocatedTicket += (titem.quantity === -1 ? titem.bought + titem.activated : titem.quantity);
      const { promoterId, referral } = titem;
      if (promoterId === undefined || promoterId === null) {
        ticketInventory.public.push(titem);
      } else {
        if (referral) {
          ticketInventory.private.push(titem);
        }
      }
    });

    // Map for key: _id val: index in array - public / private key of ticketInventory state
    const ticketInventoryMap: { private: any; public: any } = {
      private: {},
      public: {}
    };
    const ticketInventoryPromoterMap: any = {};

    // Building hashmap : id  --> <-- Index
    ticketInventory.public.forEach((val: any, index: number) => {
      ticketInventoryMap.public[val._id] = index;
    });
    ticketInventory.private.forEach((val: any, index: number) => {
      ticketInventoryMap.private[val._id] = index;
      // if promoter id is not in map...
      if (!ticketInventoryPromoterMap[val.promoterId]) {
        ticketInventoryPromoterMap[val.promoterId] = [];
      }
      // if ticket is not in promoter's array map
      if (ticketInventoryPromoterMap[val.promoterId].indexOf(val._id) === -1) {
        ticketInventoryPromoterMap[val.promoterId].push(val._id);
      }
    });

    const capacityRemaining = props.capacity - totalAllocatedTicket < 0 ? 0 : props.capacity - totalAllocatedTicket;

    let ticketInventoryInactiveMap = {};
    let deletedUsers = [''];

    Object.keys(ticketInventoryPromoterMap).map((key) => {

      // value stored in ticketInventoryPromoterMap[key]
      // key in key

      if (this.props.users[key] === undefined || this.props.users[key] === null) {
        ticketInventoryInactiveMap = { ...ticketInventoryInactiveMap, [key]: ticketInventoryPromoterMap[key] }
        delete ticketInventoryPromoterMap[key];
        deletedUsers = [...deletedUsers, key]
      }
    })
    deletedUsers.splice(0, 1);

    // ticketInventoryInactiveMap will have only have deleted users
    // which will be moved in from the promoter map
    // now we have to retrieve users
    fetchGraphQL(getUsers(), JSCookie.get("token"), {
      ids: deletedUsers
    }).then((res) => {
      if (res !== undefined && res !== null) {
        // console.log(res.user.findByIds)
        this.setState({
          deletedUsers: res.user.findByIds,
          ticketInventoryPublic: ticketInventory.public,
          ticketInventoryPrivate: ticketInventory.private,
          ticketInventoryMap,
          capacityRemaining,
          ticketInventoryPromoterMap,
          ticketInventoryInactiveMap
        })
      }
    })


    // set to state
    this.setState({
      ticketInventoryPublic: ticketInventory.public,
      ticketInventoryPrivate: ticketInventory.private,
      ticketInventoryMap,
      ticketInventoryPromoterMap,
      capacityRemaining,
      ticketInventoryInactiveMap
    });

  }

  public findTicketInventoryItemByIndex(
    id: string
  ): { domain: TicketInventoryDomain; index: number; quantity: number } {
    const { ticketInventoryMap } = this.state;
    let quantity = 0;
    this.props.ticketInventory.forEach((titem: any) => {
      if (titem._id === id) {
        quantity = titem.quantity;
      }
    });
    if (ticketInventoryMap.public[id] !== undefined) {
      return {
        domain: TicketInventoryDomain.PUBLIC,
        index: ticketInventoryMap.public[id],
        quantity
      };
    } else if (ticketInventoryMap.private[id] !== undefined) {
      return {
        domain: TicketInventoryDomain.PRIVATE,
        index: ticketInventoryMap.private[id],
        quantity
      };
    }
    return {
      domain: TicketInventoryDomain.PUBLIC,
      index: -1,
      quantity,
    };
  }

  /**
   * Handles quantity change of ticket inventory item.
   *
   * @param payload
   */
  public handleQuantityChange(payload: { _id: string; quantity: number }) {
    // Cannot exceed the event capacity
    if (this.state.capacityRemaining - payload.quantity < 0) {
      return;
    }

    const { ticketInventoryPrivate } = this.state;
    const ticketIndex = this.findTicketInventoryItemByIndex(payload._id);

    // Simple wrapped fetch to graphql, to minimize repetetivity,
    // But there is also the more elegant way to refactor this :)
    const doRequestWrapped = (id: string, quantity: number): Promise<any> => {
      return fetchGraphQL(updateQuantity(), undefined, {
        ticketBankItem: {
          _id: id,
          quantity,
          eventId: this.props.eventId
        }
      });
    };

    doRequestWrapped(
      ticketInventoryPrivate[ticketIndex.index]._id,
      ticketInventoryPrivate[ticketIndex.index].quantity + payload.quantity
    ).then((value: any) => {
      const response = value.ticketBank.update;
      ticketInventoryPrivate[ticketIndex.index].quantity =
        response.quantity;
      this.setState({
        ticketInventoryPrivate,
        capacityRemaining: this.state.capacityRemaining - payload.quantity
      });
    });

  }

  /**
   * Used to enable / disable ticket inventory item
   *
   * @param payload payload is used for update query
   */
  public handleEnabled(payload: { _id: string; enabled: boolean }) {
    const { _id, enabled } = payload;

    const ticketIndex = this.findTicketInventoryItemByIndex(payload._id);

    fetchGraphQL(disable(), undefined, {
      ticketBankItem: {
        _id,
        enabled
      }
    }).then((value: any) => {
      // const response = value.ticketBank.update;
      const { ticketInventoryPublic, ticketInventoryPrivate } = this.state;
      switch (ticketIndex.domain) {
        case TicketInventoryDomain.PUBLIC:
          ticketInventoryPublic[ticketIndex.index].enabled = enabled;
          this.setState({ ticketInventoryPublic });
          break;
        case TicketInventoryDomain.PRIVATE:
          ticketInventoryPrivate[ticketIndex.index].enabled = enabled;
          this.setState({ ticketInventoryPrivate });
          break;
      }
    });
  }

  /**
   * Used to delete ticket inventory item
   *
   * @param payload payload is used for update query
   */
  public handleDelete(payload: { _id: string }) {
    const { _id } = payload;
    const ticketIndex = this.findTicketInventoryItemByIndex(_id);

    fetchGraphQL(deleteTicketItem(), undefined, {
      ticketBankItem: {
        _id,
        eventId: this.props.eventId
      }
    }).then((value: any) => {
      // const response = value.ticketBank.update;
      const { ticketInventoryPublic, ticketInventoryPrivate } = this.state;
      const capacityRemaining = this.state.capacityRemaining + ticketIndex.quantity;

      switch (ticketIndex.domain) {
        case TicketInventoryDomain.PUBLIC:
          delete ticketInventoryPublic[ticketIndex.index];
          this.setState({
            ticketInventoryPublic,
            capacityRemaining
          });
          break;
        case TicketInventoryDomain.PRIVATE:
          delete ticketInventoryPrivate[ticketIndex.index];
          this.setState({
            ticketInventoryPublic,
            capacityRemaining
          });
          break;
      }
      // this.setState({...this.state, redirect: true});
      // window.location.reload(); 
    });
  }

  public handleCloseModal() {
    this.setState({
      ticketInventoryNew: {
        name: null,
        quantity: null,
        promoterId: null,
        referral: true,
        description: null
      }
    });
    closeModal();
  }
  /**
   * Handles creation of item, and also on finish, it adds the item into state.
   */
  public handleCreateItem(e: any) {
    e.preventDefault();
    const {
      ticketInventoryNew,
      // ticketInventoryMap,
      // ticketInventoryPrivate
    } = this.state;

    if (ticketInventoryNew.name === null || ticketInventoryNew.name === "") {
      return;
    }

    if (ticketInventoryNew.price === null || ticketInventoryNew.price === "") {
      return;
    }

    if (ticketInventoryNew.quantity === null || ticketInventoryNew.quantity === "") {
      return;
    }

    if (ticketInventoryNew.promoterId === null || ticketInventoryNew.promoterId === "") {
      return;
    }

    // ticketInventoryNew.price = ticketInventoryNew.price * 100;
    const quantity = Number(ticketInventoryNew.quantity);
    delete ticketInventoryNew.quantity;
    ticketInventoryNew.quantity = quantity;
    delete ticketInventoryNew.isChanged;

    const promoterIdsUnfiltered = ticketInventoryNew.promoterId.split(',')
    let i = 0;

    const promoterIds = promoterIdsUnfiltered.filter((elem, pos) => {
      return promoterIdsUnfiltered.indexOf(elem) === pos;
    })

    if (ticketInventoryNew.quantity * promoterIds.length > this.state.capacityRemaining) {
      return;
    }

    while (i < promoterIds.length) {
      fetchGraphQL(i === promoterIds.length - 1 ? createTicketBankItem() : createTicketBankItemWithoutWebsocket(), undefined, {
        ticketBankItem: {
          ...ticketInventoryNew,
          price: ticketInventoryNew.price * 100,
          referral: true,
          eventId: this.props.eventId,
          promoterId: promoterIds[i] || undefined,
          description: ticketInventoryNew.description ? ticketInventoryNew.description : null
        }
      }).then(ticketBank => {
        this.reloadData(Math.random(), 1);
      });
      i++
    }
    // window.location.reload()
  }

  /**
   * Handle input changes in modal...
   */

  public handleModalInputChange(e: any) {
    const { value, name } = e.target;
    if (name === 'quantity' && isNaN(Number(value))) {
      e.target.setCustomValidity("Input type should be a number");
      return;
    }
    if (name === 'price' && isNaN(Number(value))) {
      e.target.setCustomValidity("Input type should be a number");
      return;
    }
    if (name === "quantity" && Number(value) > this.state.capacityRemaining) {
      e.target.setCustomValidity("Ticket quantity must be less than or equal to the remaining event capacity (" + this.state.capacityRemaining + ")");
      return;
    }
    const temp = this.state.ticketInventoryNew;
    temp[e.target.name] = e.target.value;
    this.setState({
      ticketInventoryNew: temp
    });
    if (name === "quantity" && Number(value) > this.state.capacityRemaining) {
      e.target.setCustomValidity("Ticket quantity must be less than or equal to the remaining event capacity (" + this.state.capacityRemaining + ")");
    }
  }

  public handleAddTicket(
    type: TicketInventoryDomain = TicketInventoryDomain.PRIVATE,
    promoterId: string
  ) {


    const { eventId } = this.props;
    fetchGraphQL(getTicketBankItemsAsString(), JSCookie.get("token"), {
      eventId
    }).then((resultInventory: any) => {
      const eventTicketInventory: any[] = JSON.parse(resultInventory.ticketBank.getAsString) || [];
      this.mapTicketInventoryState(eventTicketInventory);
      this.setState({
        ticketInventoryNew: {
          name: null,
          quantity: null,
          price: null,
          promoterId: promoterId || null,
          description: null
        }
      });

      this.setPromoter(promoterId)
      const content = (
        <CreateTicketModal
          ticketType={type}
          privateAdd={true}
          remainingCapacity={this.state.capacityRemaining}
          onChange={this.handleModalInputChange}
          onClose={this.handleCloseModal}
          onCreate={this.handleCreateItem}
          users={this.props.users}
          promoterId={promoterId}
          currentPromoter={this.state.ticketInventoryNew.promoterId}
          eventId={eventId}
          currency={this.props.currency}
        />
      );

      openModal(content, "Add Referral Tickets for " + this.props.users[promoterId!].name + ' ' + this.props.users[promoterId!].lastname, [
      ]);
    });


  }

  public setPromoter(prom: string) {
    const ticketInventoryNew = this.state.ticketInventoryNew;
    ticketInventoryNew.promoterId = prom;
    this.setState({ ticketInventoryNew })
  }

  /**
   * used to create private / public ticket inv. item
   *
   * @param type public / private
   */
  public handleOpenCreateModal(
    type: TicketInventoryDomain = TicketInventoryDomain.PRIVATE,
    promoterId?: string
  ) {

    const { eventId } = this.props;

    fetchGraphQL(getTicketBankItemsAsString(), JSCookie.get("token"), {
      eventId
    }).then((resultInventory: any) => {
      const eventTicketInventory: any[] = JSON.parse(resultInventory.ticketBank.getAsString) || [];
      this.mapTicketInventoryState(eventTicketInventory);
      const { promoters } = this.props;
      const { hosts } = this.props;
      const temp = [...promoters, ...hosts]
      const error = temp.length > 0 ? false : true;
      // if (!error) {
      //   this.setState({
      //     ticketInventoryNew: {
      //       referral: true,
      //       name: null,
      //       quantity: null,
      //       price: null,
      //       promoterId: temp[0],
      //       description: null
      //     }
      //   });
      // } else {
      this.setState({
        ticketInventoryNew: {
          referral: true,
          name: null,
          quantity: null,
          price: null,
          promoterId: null,
          description: null
        }
      });
      // }

      // if (!error) {
      //   this.setPromoter(temp[0])
      // }

      const content = error === false ? (
        <CreateTicketModal
          ticketType={type}
          privateAdd={false}
          remainingCapacity={this.state.capacityRemaining}
          onChange={this.handleModalInputChange}
          onClose={this.handleCloseModal}
          onCreate={this.handleCreateItem}
          users={this.props.users}
          promoters={temp}
          currentPromoter={this.state.ticketInventoryNew.promoterId}
          eventId={eventId}
          currency={this.props.currency}
          referral={true}
          setPromoter={this.setPromoter}
        />
      ) : (<div>
        <Error content={"No Team Members Found for Private Ticket Allocation"} />
        <div className="Seperate-Buttons">
          <button
            className='btn new-button-white-3'
            style={{ border: 'none' }}
            onClick={e => this.handleCloseModal()}
          >
            CANCEL
          </button>
        </div>
      </div>
        );

      openModal(content, "Create Referral Link Tickets for Team Members", [
      ]);
    });
  }

  public render() {

    const divKey = JSON.parse(JSON.stringify(this.state))
    delete divKey.ticketInventoryNew;

    const ticketInventoryUpdate = gql`
    subscription {
      updatedTicketInventory(eventId:"${this.props.eventId}")
    }
    `;

    const ticketPurchase = gql`
    subscription {
      ticketPurchase(eventIds:"${this.props.eventId}")
    }
    `;

    const eventInformationUpdate = gql`
  subscription {
    eventDetailsUpdated(eventId:"${this.props.eventId}")
  }
  `;

    const ticketCheckin = gql`
    subscription {
      ticketCheckin(eventIds:"${this.props.eventId}")
    }
    `;

    const {
      ticketInventoryPrivate,
      ticketInventoryMap
    } = this.state;

    const totalSalesMap = {}

    ticketInventoryPrivate.map(item => {
      if (item.referral !== undefined && item.referral === true) {
        if (totalSalesMap[item.promoterId] !== undefined) {
          totalSalesMap[item.promoterId] += item.bought;
        } else {
          totalSalesMap[item.promoterId] = item.bought;
        }
      }
    })

    return (
      <div>
        <div>
          <Subscription subscription={ticketInventoryUpdate}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.updatedTicketInventory !== null) {
                if (data.updatedTicketInventory !== this.state.updateString) {
                  return <img height={0} width={0} onLoad={this.reloadData(data.updatedTicketInventory, 1)} style={{ display: 'none' }} />
                }
                return null;
              }
              return null;
            }}
          </Subscription>
          <Subscription subscription={eventInformationUpdate}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.eventDetailsUpdated !== null) {
                if (data.eventDetailsUpdated !== this.state.updateString1) {
                  return <img height={0} width={0} onLoad={this.reloadData(data.eventDetailsUpdated, 2)} style={{ display: 'none' }} />
                }
              }
              return null;
            }}
          </Subscription>
          <Subscription subscription={ticketCheckin}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.ticketCheckin !== null) {
                if (data.ticketCheckin !== this.state.updateString2) {
                  return <img height="0" width="0" style={{ display: 'none' }} onLoad={this.reloadData(data.ticketCheckin, 3)} />
                }
                return null;
              }
              return null;
            }}
          </Subscription>
          <Subscription subscription={ticketPurchase}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.ticketPurchase !== null) {
                if (data.ticketPurchase !== this.state.updateString3) {
                  return <img height="0" width="0" style={{ display: 'none' }} onLoad={this.reloadData(data.ticketPurchase, 4)} />
                }
                return null;
              }
              return null;
            }}
          </Subscription>
        </div>
        <Card >
          <CardHeader style={{ borderTopLeftRadius: '15px', borderTopRightRadius: '15px', backgroundColor: '#f1f1f1', border: 'none' }}>
            <div style={{ width: '100%' }}>
              <div style={{ float: 'left', paddingLeft: '30px', lineHeight: '38px', paddingTop: '10px', color: '#f8f8f8' }}>
                <h3>Referral Links</h3>
              </div>
              <div style={{ float: 'right', paddingTop: '5px' }}>
                <button
                  className="new-button-save"
                  onClick={e =>
                    this.handleOpenCreateModal(TicketInventoryDomain.PRIVATE)
                  }
                  style={{ border: 'none' }}
                >
                  +
                </button>
              </div>
            </div>
          </CardHeader>
          <ContentLoader isLoading={this.state.loading}>
            <div
              key={JSON.stringify(divKey)}
            >
              <p />
              {Object.keys(this.state.ticketInventoryPromoterMap).length > 0 ? (
                Object.keys(this.state.ticketInventoryPromoterMap).map(key => {
                  const ticketIds: string[] = this.state
                    .ticketInventoryPromoterMap[key];

                  const user = this.state.teamMap.teamMap.find(item => {
                    return item.userId === this.props.users[key].id
                  })

                  let index = '';
                  if (user !== undefined) {
                    index = user.index
                  }

                  const subdomain = this.state.teamMap.customSubdomain ? this.state.teamMap.customSubdomain : ''
                  const referralLink = subdomain !== '' && this.props.users[key].email.includes('@isotope-referral-code.com')
                    ? ('https://' + subdomain + '.isotopeticketing.com/' + this.props.users[key].email.split('@')[0])
                    : (AppConfig.hostUrl === 'https://platform.isotopeticketing.com' ? 'http://istkt.com/event-' + this.state.teamMap.code + '-' + index
                      : AppConfig.hostUrl + "/event-" + this.state.teamMap.code + '-' + index)

                  return (
                    <Card key={"promoter-tickets-" + key} style={{ boxShadow: 'none' }}>
                      <div style={{ width: '100%', minHeight: '50px' }}>
                        <div>
                          <span style={{ paddingRight: '20px', paddingLeft: '20px' }}>
                            {this.state.showMap[key] !== undefined && this.state.showMap[key] === true ?
                              <button
                                className="new-button-white-4"
                                onClick={e =>
                                  this.showOrHide(key)
                                }
                                style={{
                                  border: 'none'
                                }}
                              >
                                HIDE
                              </button> :
                              <button
                                className="new-button-white-4"
                                onClick={e =>
                                  this.showOrHide(key)
                                }
                                style={{
                                  border: 'none'
                                }}
                              >
                                SHOW
                              </button>
                            }
                          </span>
                          <span style={{ paddingRight: '20px' }}>
                            <button
                              className="new-button-white-4"
                              onClick={e =>
                                this.handleAddTicket(
                                  TicketInventoryDomain.PRIVATE,
                                  key
                                )
                              }
                            >
                              ADD
                        </button>
                          </span>
                          {
                            this.props.users[key] !== undefined
                              ?
                              <span>
                                <span style={{ paddingRight: '0px', paddingLeft: '10px' }}>
                                  <a
                                    href={referralLink}
                                    className='new-button-white-4'
                                  >
                                    LINK
                                  </a>
                                </span>
                                <span className='sexyBlack' style={{ paddingLeft: '2px' }}>
                                  &nbsp;&nbsp;&nbsp;
                                {user.referralLinkViews ?
                                    (user.referralLinkViews === 1 ? '( ' + user.referralLinkViews + ' VIEW )' : '( ' + user.referralLinkViews + ' VIEWS )')
                                    : '( 0 VIEWS )'
                                  }
                                </span>
                              </span>
                              : null
                          }

                          <div style={{ paddingRight: '20px' }}>
                            <Label>&nbsp;&nbsp;&nbsp;
                            <span className="sexyBlack">
                                {this.props.users[key]
                                  ? this.props.users[key].name +
                                  " " +
                                  (this.props.users[key].lastname || "") || ""
                                  : key}
                              </span>
                            &nbsp;&nbsp;Total Sales:&nbsp;&nbsp;
                          {totalSalesMap[key] || 0}
                              {
                                this.state.showMap[key] !== undefined && this.state.showMap[key] === true ?
                                  (!this.props.users[key].email.includes('@isotope-referral-code.com') ?
                                    <span>&nbsp;&nbsp;({this.props.users[key].email})&nbsp;&nbsp;</span>
                                    : <span>&nbsp;&nbsp;(Referral Code: {this.props.users[key].email.split('@')[0]})&nbsp;&nbsp;</span>)
                                  : null
                              }
                            </Label>
                          </div>

                        </div>
                      </div>

                      <Collapse isOpen={this.state.showMap[key] !== undefined && this.state.showMap[key] === true} className="scrollable">

                        <table
                          className='table-responsive--base'
                          style={{ minWidth: '1150px' }}
                        >
                          <TicketInventoryTableHeader type={"public"} />
                          <tbody>
                            {ticketIds.length > 0
                              ? ticketIds.map(ticketId => {
                                const titem =
                                  ticketInventoryPrivate[
                                  ticketInventoryMap.private[ticketId]
                                  ];


                                if (titem !== undefined) {
                                  return (
                                    <TicketInventoryItem
                                      type={"public"}
                                      key={"tinv-item-" + titem._id}
                                      onAdd={this.handleQuantityChange}
                                      onSubstract={this.handleQuantityChange}
                                      onEnable={this.handleEnabled}
                                      onDisable={this.handleEnabled}
                                      onDelete={this.handleDelete}
                                      data={titem}
                                      reloadOnSave={this.reloadData}
                                      currency={this.props.currency}
                                      capacityRemaining={this.state.capacityRemaining}
                                      description={titem.description ? titem.description : null}
                                    />
                                  );
                                }
                              })
                              : null}
                          </tbody>
                        </table>
                      </Collapse>
                      <hr />
                    </Card>
                  );
                })
              ) : (
                  null
                )}
              {Object.keys(this.state.ticketInventoryInactiveMap).length > 0 ? (
                Object.keys(this.state.ticketInventoryInactiveMap).map(key => {

                  const ticketIds: string[] = this.state.ticketInventoryInactiveMap[key];
                  const user = this.state.deletedUsers.find((item) => {
                    return item.id === key
                  })

                  return (
                    <Card key={"promoter-tickets-" + key} style={{ boxShadow: 'none' }}>
                      <div style={{ width: '100%', minHeight: '50px' }}>
                        <div>
                          <span style={{ paddingRight: '20px', paddingLeft: '20px' }}>
                            {this.state.showMap[key] !== undefined && this.state.showMap[key] === true ?
                              <button
                                className="new-button-white-4"
                                onClick={e =>
                                  this.showOrHide(key)
                                }
                                style={{
                                  border: 'none'
                                }}
                              >
                                HIDE
                            </button> :
                              <button
                                className="new-button-white-4"
                                onClick={e =>
                                  this.showOrHide(key)
                                }
                                style={{
                                  border: 'none'
                                }}
                              >
                                SHOW
                            </button>
                            }
                          </span>
                          <div>
                            <Label>
                              <span>
                                <span style={{ color: '#FF5244', paddingLeft: '10px' }}>(Deleted team member)<br /></span>
                                <span className="sexyBlack" style={{ paddingLeft: '10px' }}>

                                  {user
                                    ? user.name +
                                    " " +
                                    (user.lastname || "") || ""
                                    : key}

                                </span>
                                <span className='sexyBlack' style={{ paddingLeft: '2px' }}>
                                  &nbsp;&nbsp;&nbsp;
                                {user && user.referralLinkViews ?
                                    (user.referralLinkViews === 1 ? '( ' + user.referralLinkViews + ' VIEW )' : '( ' + user.referralLinkViews + ' VIEWS )')
                                    : '( 0 VIEWS )'
                                  }
                                </span>
                              </span>
                            &nbsp;&nbsp;Total Sales:&nbsp;&nbsp;
                            {totalSalesMap[key] || 0}
                              {
                                this.state.showMap[key] !== undefined && this.state.showMap[key] === true ?
                                  <span>&nbsp;&nbsp;({user.email})&nbsp;&nbsp;</span> : null
                              }
                            </Label>
                          </div>
                        </div>
                      </div>

                      <Collapse isOpen={this.state.showMap[key] !== undefined && this.state.showMap[key] === true} className="scrollable">
                        <table className="w-100 table-responsive--base" style={{ minWidth: '1150px' }}>
                          <TicketInventoryTableHeader type={"private"} />
                          <tbody>
                            {ticketIds.length > 0
                              ? ticketIds.map(ticketId => {
                                const titem =
                                  ticketInventoryPrivate[
                                  ticketInventoryMap.private[ticketId]
                                  ];

                                if (titem !== undefined) {
                                  return (
                                    <TicketInventoryItem
                                      type={"private"}
                                      key={"tinv-item-" + titem._id}
                                      onAdd={this.handleQuantityChange}
                                      onSubstract={this.handleQuantityChange}
                                      onEnable={this.handleEnabled}
                                      capacityRemaining={this.state.capacityRemaining}
                                      onDisable={this.handleEnabled}
                                      onDelete={this.handleDelete}
                                      data={titem}
                                      deletedUser={true}
                                      reloadOnSave={this.reloadData}
                                      currency={this.props.currency}
                                      description={titem.description ? titem.description : null}
                                    />
                                  );
                                }
                              })
                              : null}
                          </tbody>
                        </table>
                      </Collapse>
                      <hr />
                    </Card>
                  );
                })
              ) : (
                  null
                )}
              {Object.keys(this.state.ticketInventoryPromoterMap).length === 0 && Object.keys(this.state.ticketInventoryInactiveMap).length === 0
                ? <div className="text-center"><p>No referral links created yet.</p></div> : <p style={{ width: '100%', textAlign: 'center', fontSize: '12px' }}>
                  &infin; No fixed quota, can sell up to event capacity.
            </p>}
            </div>
          </ContentLoader>
        </Card>
        <p><br /></p>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    users: UsersDucks.getUsers(state)
  };
};

export default connect(mapStateToProps)(ReferralTicketInventory);



// WEBPACK FOOTER //
// ./src/pages/manage/events/edit/modules/ticketInventory/ReferralTicketInventory.tsx